exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ncrpcvideo{position:relative;width:100%;padding-bottom:56.25%}.ncrpcvideo iframe{position:absolute;top:0;left:0;width:100%;height:100%}\n", ""]);

